import { render, staticRenderFns } from "./ShopItemPrice.vue?vue&type=template&id=0122fab9&scoped=true&"
import script from "./ShopItemPrice.vue?vue&type=script&lang=js&"
export * from "./ShopItemPrice.vue?vue&type=script&lang=js&"
import style0 from "./ShopItemPrice.vue?vue&type=style&index=0&id=0122fab9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0122fab9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/Coding/farmerspace/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardText,VContainer,VDialog,VFlex,VLayout})
